import { render, staticRenderFns } from "./students.vue?vue&type=template&id=05b6c21e&scoped=true"
import script from "./students.vue?vue&type=script&lang=js"
export * from "./students.vue?vue&type=script&lang=js"
import style0 from "./students.vue?vue&type=style&index=0&id=05b6c21e&prod&lang=scss"
import style1 from "./students.vue?vue&type=style&index=1&id=05b6c21e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b6c21e",
  null
  
)

export default component.exports